import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { TContentBlockBase } from '@onesource/schemas';
import { MdVideocam } from 'react-icons/md';

interface ZoomCardProps {
  block: TContentBlockBase;
  onClick: () => void;
}

export const ZoomCard = ({ block, onClick }: ZoomCardProps) => (
  <Box
    onClick={onClick}
    sx={{
      width: 107,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 1.25,
      cursor: 'pointer',
      transition: 'all 0.2s',
      '&:hover': { opacity: 0.8, transform: 'translateY(-2px)' },
    }}
  >
    <Box
      sx={{
        width: 53,
        height: 65,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#EBF5FF',
        borderRadius: 2,
      }}
    >
      <MdVideocam size={32} color="#2D8CFF" />
    </Box>
    <Typography variant="caption" sx={{ color: '#808080', fontSize: '12px', textAlign: 'center', lineHeight: 1.3 }}>
      {block.title || 'Zoom Session'}
    </Typography>
  </Box>
);
